import { gql } from '@apollo/client';
import {
  LOCATION_FRAGMENT,
  OFFICE_FRAGMENT,
  REGION_FRAGMENT,
} from 'modules/locations/graphql/fragments';

export const GET_LOCATIONS_QUERY = gql`
  query getLocations($input: GetLocationsInput!) {
    getLocations(input: $input) {
      data {
        ...Location
      }
      meta {
        total
      }
    }
  }
  ${LOCATION_FRAGMENT}
`;

export const GET_PUBLIC_LOCATIONS_QUERY = gql`
  query getPublicLocations($input: GetPublicLocationsInput!) {
    getPublicLocations(input: $input) {
      data {
        ...Location
      }
      meta {
        total
      }
    }
  }
  ${LOCATION_FRAGMENT}
`;

export const GET_LOCATION_WITH_AVAILABLE_DAYCARE = gql`
  query getLocationWithAvailableDaycare {
    getLocationWithAvailableDaycare {
      ...Location
    }
  }
  ${LOCATION_FRAGMENT}
`;

export const GET_REGIONS_QUERY = gql`
  query getRegions {
    getRegions {
      ...Region
    }
  }
  ${REGION_FRAGMENT}
`;

export const GET_PUBLIC_REGIONS_QUERY = gql`
  query getPublicRegions {
    getPublicRegions {
      id
      name
    }
  }
`;

export const GET_OFFICES_QUERY = gql`
  query getOffices {
    getOffices {
      ...Office
    }
  }
  ${OFFICE_FRAGMENT}
`;
